'use strict';

import config from '../../../js/config';

var Backbone = require('backbone'),
  $global = require('../../../js/globalElements'),
  mediator = require('../../../js/mediator'),
  cacheCookieHelper = require('../../../components/CacheCookieHelper/CacheCookieHelper'),
  cookies = require('js-cookie'),
  personalData = null

const OVERLAY_CLASSES = `${config.classes.hasHeaderDropdown}`;

var LanguageDropdownItemView = Backbone.View.extend({

  events: {
    'click .js-language-dropdown-item': 'languageDropdownItemClick',
    'click .linkList-item a': 'updateLanguageOnClick'
  },

  initialize: function(options) {
    personalData = options.model.personalizedData;
    this.useCachedData();
  },

  updateLanguageOnClick: function() {
    var selectedLang = event.target.attributes['data-gtm-label'].value;
    cookies.set(config.cookies.arrowLanguage, selectedLang, { domain: config.cookies.domain });
    if (cacheCookieHelper) {
      cacheCookieHelper.setCacheCookie();
    }
  },

  languageDropdownItemClick: function() {
    mediator.trigger(config.events.showHide.hideGroupHeader, {});
    $global.$body.removeClass(OVERLAY_CLASSES);
  },

  setLanguageDropdownValue: function() {
    let selectedLanguage = this.getSelectedLanguage();
    if (selectedLanguage && selectedLanguage.Code) {
      this.$el.siblings('a.js-language-dropdown').find('span.Header-navBar-item--dropdown-name').html(selectedLanguage.Code);
    }
  },

  getSelectedLanguage: function() {
    if (this.$el.siblings('.AvailableLanguagesJson')[0]) {
      var availableLanguages = JSON.parse(this.$el.siblings('.AvailableLanguagesJson')[0].innerHTML);
      let userLanguage = cookies.get(config.cookies.arrowLanguage);
      let downcasedUserLanguage = 'en';
      if (personalData.language) {
        downcasedUserLanguage = personalData.language.toLowerCase();
      }
      else if (userLanguage) {
        downcasedUserLanguage = userLanguage.toLowerCase();
      }
      else {
        if (window.location.hostname.indexOf('.de') > 1) {
          downcasedUserLanguage = 'de-de';
        }
      }
      let selectedLanguage = null;
      availableLanguages[0].forEach((element) => {
        if (element.Name.toLowerCase() === downcasedUserLanguage) {
          selectedLanguage = element;
        }
      });
      return selectedLanguage;
    }
  },

  useCachedData: function() {
    this.setLanguageDropdownValue();
  }
});

module.exports = LanguageDropdownItemView;





// WEBPACK FOOTER //
// ./assets/components/Header/js/LanguageDropdownItemView.js